import { render } from "./category-wizard.vue?vue&type=template&id=1fdb9aec&scoped=true&ts=true"
import script from "./category-wizard.vue?vue&type=script&lang=ts"
export * from "./category-wizard.vue?vue&type=script&lang=ts"

import "./category-wizard.vue?vue&type=style&index=0&id=1fdb9aec&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fdb9aec"]])

export default __exports__